/**
 * Skeleton — indeterminate data-loading placeholder (theme T5c §4.3).
 *
 * Shimmers L→R over 1.4 s ease-in-out.  Static bg under
 * prefers-reduced-motion (the animation class is no-op in that case).
 *
 * Use for table-row / card-body placeholders whose final shape is known.
 * For operations with determinate progress, use a progress bar instead.
 */
import { cn } from './cn';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export function Skeleton({ className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn(
        'relative overflow-hidden rounded-md bg-slate-200',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.4s_ease-in-out_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/40 before:to-transparent motion-reduce:before:hidden',
        className,
      )}
      {...rest}
    />
  );
}

/** Matching keyframes should live in globals.css under @layer utilities. */
